import {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {MeuEscopo, recordServiceLevelActivity, ServiceLevelActivity} from './api'
import {hasServiceLevelPermission} from './permissions'

export function screenActivity(path: string, scope: MeuEscopo | null): ServiceLevelActivity | null {
  if (!scope) return null
  const pathname = path.replace(/\/+$/, '')
  if (pathname === '/service-level/dashboard') return 'dashboard_view'
  if (pathname === '/service-level/admin')
    return hasServiceLevelPermission(scope, 'sync') ? 'sync_view' : null
  if (pathname === '/service-level/admin/sla-sellers')
    return hasServiceLevelPermission(scope, 'sla_sellers') ? 'sla_sellers_view' : null
  if (pathname === '/service-level/admin/regioes-slas')
    return hasServiceLevelPermission(scope, 'regioes_slas') ? 'regioes_slas_view' : null
  if (/^\/service-level\/sellers\/[^/]+$/.test(pathname) && scope.detail_level >= 2)
    return 'seller_view'
  if (/^\/service-level\/industrias\/[^/]+$/.test(pathname) && scope.detail_level >= 2)
    return 'industria_view'
  if (/^\/service-level\/pedidos\/[^/]+$/.test(pathname) && scope.detail_level >= 3)
    return 'pedido_view'
  return null
}

export default function useScreenActivity(scope: MeuEscopo | null) {
  const {pathname} = useLocation()
  const lastScreen = useRef<string | null>(null)
  useEffect(() => {
    const action = screenActivity(pathname, scope)
    if (!action) {
      lastScreen.current = null
      return
    }
    if (pathname === lastScreen.current) return
    lastScreen.current = pathname
    void recordServiceLevelActivity(action)
  }, [pathname, scope])
}
